import { jsx as _jsx } from "react/jsx-runtime";
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import classNames from 'pricing-pages-ui/utils/classNames';

const LoadingMerchCardPublicCTAs = props => {
  const {
    containterStyle = {},
    ctaStyles = {},
    className,
    numPurchaseMotions,
    maxNumPurchaseMotions
  } = props;
  const loadingButtonCount = Math.min(numPurchaseMotions, maxNumPurchaseMotions);
  const loadingButtons = [];

  for (let i = 0; i < loadingButtonCount; i++) {
    loadingButtons.push( /*#__PURE__*/_jsx(UILoadingButton, {
      use: "primary",
      loading: true,
      className: classNames(i < loadingButtonCount - 1 && 'm-bottom-2', 'm-x-0'),
      style: ctaStyles,
      children: "Loading"
    }, i));
  }

  return /*#__PURE__*/_jsx("div", {
    style: Object.assign({}, containterStyle),
    className: classNames(className, 'flex-column align-center'),
    children: loadingButtons
  });
};

export default LoadingMerchCardPublicCTAs;